import { render } from "./PrintTools.vue?vue&type=template&id=4f126e25&scoped=true"
import script from "./PrintTools.vue?vue&type=script&lang=js"
export * from "./PrintTools.vue?vue&type=script&lang=js"

import "./PrintTools.vue?vue&type=style&index=0&id=4f126e25&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f126e25"]])

export default __exports__